import { Controller } from '@hotwired/stimulus'
import { prefersReducedMotion } from '../utils/document'

export default class extends Controller {
  static classes = ['hidden', 'shown']

  connect() {
    if (prefersReducedMotion() || !('IntersectionObserver' in window)) return

    this.element.classList.add(this.hiddenClass)
    this.observer = new IntersectionObserver(this.#onIntersect.bind(this), { threshold: 0.12 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  #onIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      this.element.classList.remove(this.hiddenClass)
      this.element.classList.add(this.shownClass)
      this.observer.unobserve(this.element)
    })
  }
}
